// extracted by mini-css-extract-plugin
module.exports = {"page":"not-found_page__zNdLZ","page__content":"not-found_page__content__mt2XE","page__heading":"not-found_page__heading___xb3e"};